import { initializeDatadog } from './init'

initializeDatadog()

export * from './logger'
